import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from './actions';
import ListaAcoes from '../../components/ListaAcoes';

import constants from './constants';

class ListaRoles extends Component {
  render() {
    let { value, actions } = this.props;

    return (
      <ListaAcoes
        title="Roles"
        value={value}
        actions={{
          onLoad: actions.onLoadListRoles,
          onCancel: actions.onChangeListRoles(constants.Status.CANCELADA),
          onApprove: actions.onChangeListRoles(constants.Status.CONFIRMADA),
          onCreate: actions.onChangeListRoles(constants.Status.CONFIRMADA)
        }}
        labelFn={item => (
          <details><summary>
            {item.nome} : {item.nome_usuario}
            <br />
            {item.apartamento} {item.nome_contratante}</summary>
            <ul>
              <li>{item.email_usuario}</li>
            </ul>
          </details>
        )}
      />
    );
  }
}

let mapStateToProps = ({ admin: { roles } }) => ({
  value: roles
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaRoles);



// WEBPACK FOOTER //
// ./src/modules/admin/ListaRoles.js